import React, { useEffect, useState } from 'react'
// import { getBTCprice } from './api'
import useRefresh from './useRefresh'

export const coingeckoUrl = `https://api.coingecko.com/api/v3/coins`


const getBTCprice = async (vs_currency, currency_id) => {
    return fetch(
      `${coingeckoUrl}/markets?vs_currency=${vs_currency}&ids=${currency_id}&order=market_cap_desc&per_page=100&page=1&sparkline=false`,
    ).then((data) => {
      return data.json()
    })
  }
  
function useGetDawn() {
  const vsCurrency = 'usd'
  const currencyId = 'bitcoin'
  const { fastRefresh } = useRefresh()

  const [Dawn, setDawn] = useState('')
  const btcprice = async () => {
    const req = await getBTCprice(vsCurrency, currencyId)
    if (req) {
      if (req[0].price_change_percentage_24h >= 5) setDawn('bullish')
      else if (req[0].price_change_percentage_24h <= -5) setDawn('bearish')
    }
  }
  useEffect(() => {
    btcprice()
  }, [fastRefresh])

  return Dawn
}

export default useGetDawn
